/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SharedModule
 */

import {
    ChangeDetectionStrategy,
    Component,
} from '@angular/core';
import './avi-dropdown-single-selected-value.component.less';

/**
 * Component for a selected value in the AviDropdownComponent.
 * @author alextsg
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'avi-dropdown-single-selected-value',
    templateUrl: './avi-dropdown-single-selected-value.component.html',
    standalone: true,
})
export class AviDropdownSingleSelectedValueComponent {}
